import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import { InfoRow } from './InfrastructureSectionPanel';

const InfrastructureNetworkPanel = ({ data }) => (
    <Row className="g-3">
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Request Counts</div>
                    {data.requests && Object.entries(data.requests).map(([k, v]) => (
                        <InfoRow key={k} label={k} value={v} />
                    ))}
                    <div className="mt-2 pt-1 border-top">
                        <InfoRow label="Error Rate" value={data.errorRate} />
                    </div>
                </Card.Body>
            </Card>
        </Col>
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Response Times</div>
                    <InfoRow label="Samples" value={data.responseTimes?.samples} />
                    <InfoRow label="Avg" value={data.responseTimes?.avgMs != null ? `${data.responseTimes.avgMs} ms` : null} />
                    <InfoRow label="Min" value={data.responseTimes?.minMs != null ? `${data.responseTimes.minMs} ms` : null} />
                    <InfoRow label="Max" value={data.responseTimes?.maxMs != null ? `${data.responseTimes.maxMs} ms` : null} />
                    <InfoRow label="p50" value={data.responseTimes?.p50Ms != null ? `${data.responseTimes.p50Ms} ms` : null} />
                    <InfoRow label="p95" value={data.responseTimes?.p95Ms != null ? `${data.responseTimes.p95Ms} ms` : null} />
                    <InfoRow label="p99" value={data.responseTimes?.p99Ms != null ? `${data.responseTimes.p99Ms} ms` : null} />
                </Card.Body>
            </Card>
        </Col>
    </Row>
);

export default InfrastructureNetworkPanel;
